var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 47.4444V75.2222M57 103C50.4339 103 43.9321 101.707 37.8658 99.194C31.7995 96.6812 26.2876 92.9983 21.6447 88.3553C17.0017 83.7124 13.3188 78.2004 10.806 72.1342C8.29329 66.0679 7 59.5661 7 53C7 46.4339 8.29329 39.9321 10.806 33.8658C13.3188 27.7995 17.0017 22.2876 21.6447 17.6447C26.2876 13.0017 31.7995 9.31876 37.8658 6.80602C43.9321 4.29329 50.4339 3 57 3C70.2608 3 82.9785 8.26784 92.3553 17.6447C101.732 27.0215 107 39.7392 107 53C107 66.2608 101.732 78.9785 92.3553 88.3553C82.9785 97.7321 70.2608 103 57 103ZM57.2778 30.7778V31.3333H56.7222V30.7778H57.2778Z",
    stroke: "black",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_34",
    x: 0.25,
    y: 0.25,
    width: 113.5,
    height: 113.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_34",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2c67d9ccd66a5f9e9849a1df0cddb5e0.svg";
export { ForwardRef as ReactComponent };